export enum RowThickness {
  Thin = 'THIN',
}
